import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.TUBE_TALES;

// Game structure
export const LEVEL_COUNT = 20;
export const K2_LEVEL_COUNT = 8;
export const INTRO_SCREENS_COUNT = 2;
export const FULL_BATTERY_LIFES_COUNT = 3;

export const POSSIBLE_RESPONSE_COUNT = 2;
export const QUESTION_COUNT_TO_EARN_ZAP = 1.5;
export const CORRECT_ITEMS_TO_MASTER = 4;

export const TITLE_DIMENSIONS = [349, 53];

export const BONUS_SCHEMA_IMAGE = 'SECRET-FABLE-TURTLE';

// Curriculum Mark Up
// IDs may contain letters, numbers, hyphens (-) or underscores (_)
export const FILL_IN_BLANK_REG_EXP = /\$\{([0-9a-zA-Z-_]*)\}/;
export const FILL_IN_BLANK_REG_EXP_GLOBAL = /\$\{([0-9a-zA-Z-_]*)\}/g;
export const GENRE_CRITERIA_REG_EXP_GLOBAL = /<\/?criteria:([0-9a-zA-Z-_ ]*)>/g;
export const STORY_BLANK = '_____';

// These GAME_MODES describe all the possible states of the application for a user at any given time
// Not all of these modes will apply for every game
export const GAME_MODES = {
  // Introduction is an optional "welcome to this game" sequence that explains the conceit and narrative of game
  INTRODUCTION: 'INTRODUCTION',

  // Round play is the main interaction mode of the game when student actually plays
  // ROUND_MODES
  // Feedback occurs after student has responded to a standard question item
  FEEDBACK_POSITIVE: 'FEEDBACK_POSITIVE', // Student just answered a question correctly
  FEEDBACK_NEGATIVE: 'FEEDBACK_NEGATIVE', // Student just answered a question incorrectly
  FEEDBACK_SHOW_CORRECT: 'FEEDBACK_SHOW_CORRECT', // Show student what the correct answer actually was
  // Onboarding explains how to play the game
  ONBOARDING: 'ONBOARDING',
  // Standard item is a typical question, where student interacts with game to test their
  // skill/knowledge/understanding
  STANDARD_ITEM: 'STANDARD_ITEM',

  // View mode means no active round play is underway. Student is just viewing their status/progress in game.
  INACTIVE: 'INACTIVE',
};

export const isFeedbackMode = gameMode => (
  [GAME_MODES.FEEDBACK_POSITIVE, GAME_MODES.FEEDBACK_NEGATIVE, GAME_MODES.FEEDBACK_SHOW_CORRECT].includes(gameMode)
);

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  INTRODUCTION: 'INTRODUCTION',
  ONBOARDING: 'ONBOARDING',
  ANIMATED_TRANSITION: 'ANIMATED_TRANSITION',
};

export const ANIMATIONS = {
  BROKEN_COMPUTER: 'BROKEN_COMPUTER',
  FIXED_COMPUTER: 'FIXED_COMPUTER',
  ONBOARDING: 'ONBOARDING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  LAUNCH_ONBOARDING: 'LAUNCH_ONBOARDING',
  LEVEL_MASTERED: 'LEVEL_MASTERED',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  NEXT_STORY_PAGE: 'NEXT_STORY_PAGE',
  NEXT_INTRO_TEXT: 'NEXT_INTRO_TEXT',
  QUICK_ROUND_START: 'QUICK_ROUND_START',
  QUICK_ROUND_END: 'QUICK_ROUND_END',
  ROUND_START: 'ROUND_START',
  ROUND_END: 'ROUND_END',
  SCHEMA_UNLOCKED: 'SCHEMA_UNLOCKED',
  SHOW_CORRECT_RESPONSE: 'SHOW_CORRECT_RESPONSE',
  SELECT_FILL_IN_BLANK_RESPONSE: 'SELECT_FILL_IN_BLANK_RESPONSE',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_GAME_MODE: 'SET_GAME_MODE',
  SORT_CREATED_STORY: 'SORT_CREATED_STORY',
  SET_ANIMATION: 'SET_ANIMATION',
};

export const ALEX_STATES = {
  inactive: 0,
  active: 1,
  speaking: 2,
};
